import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ShoppingCart, User, LogOut, LayoutDashboard } from 'lucide-react';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { Button } from './ui/button';

const Navigation = ({ user, logout, cartCount }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleHome = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handleGetInTouch = () => {
    if (location.pathname === '/') {
      document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  const handleWhoWeAre = () => {
    if (location.pathname === '/') {
      document.getElementById('who-we-are').scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      setTimeout(() => {
        document.getElementById('who-we-are')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#050505]/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
          <img src="/duraplast-logo-square.png" alt="Duraplast" className="h-12" style={{filter: 'brightness(0) invert(1)'}} />
          <span className="text-3xl font-normal tracking-wider text-white" style={{fontFamily: 'Futura, sans-serif', lineHeight: '3rem'}}>DURAPLAST</span>
        </Link>

        <div className="flex items-center gap-6">
          <button 
            onClick={handleHome} 
            data-testid="nav-home" 
            className="text-sm uppercase tracking-widest hover:text-[#D4AF37] transition-colors whitespace-nowrap"
          >
            Home
          </button>
          <button 
            onClick={handleWhoWeAre} 
            data-testid="nav-who-we-are" 
            className="text-sm uppercase tracking-widest hover:text-[#D4AF37] transition-colors whitespace-nowrap"
          >
            Who We Are
          </button>
          <Link to="/shop" data-testid="nav-shop" className="text-sm uppercase tracking-widest hover:text-[#D4AF37] transition-colors whitespace-nowrap">
            Shop
          </Link>
          <Link to="/gallery" data-testid="nav-gallery" className="text-sm uppercase tracking-widest hover:text-[#D4AF37] transition-colors whitespace-nowrap">
            Gallery
          </Link>
          <Link to="/projects" data-testid="nav-projects" className="text-sm uppercase tracking-widest hover:text-[#D4AF37] transition-colors whitespace-nowrap">
            Projects
          </Link>
          <button 
            onClick={handleGetInTouch} 
            data-testid="nav-contact" 
            className="text-sm uppercase tracking-widest hover:text-[#D4AF37] transition-colors whitespace-nowrap"
          >
            Get In Touch
          </button>
          
          <div className="flex items-center gap-4">
            <a 
              href="https://www.facebook.com/duraplastengineering" 
              target="_blank" 
              rel="noopener noreferrer" 
              data-testid="facebook-link"
              className="hover:text-[#D4AF37] transition-colors"
            >
              <FaFacebook size={20} />
            </a>
            <a 
              href="https://www.instagram.com/duraplastcapetown/?hl=en" 
              target="_blank" 
              rel="noopener noreferrer" 
              data-testid="instagram-link"
              className="hover:text-[#D4AF37] transition-colors"
            >
              <FaInstagram size={20} />
            </a>
          </div>
          
          <Link to="/cart" data-testid="nav-cart" className="relative hover:text-[#D4AF37] transition-colors">
            <ShoppingCart size={20} />
            {cartCount > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-[#D4AF37] text-black text-xs w-5 h-5 flex items-center justify-center font-bold">
                {cartCount}
              </span>
            )}
          </Link>

          {user ? (
            <>
              {user.role === 'admin' && (
                <Link to="/admin" data-testid="nav-admin" className="hover:text-[#D4AF37] transition-colors">
                  <LayoutDashboard size={20} />
                </Link>
              )}
              <Link to="/account" data-testid="nav-account" className="hover:text-[#D4AF37] transition-colors">
                <User size={20} />
              </Link>
              <button onClick={logout} data-testid="logout-button" className="hover:text-[#D4AF37] transition-colors">
                <LogOut size={20} />
              </button>
            </>
          ) : (
            <button 
              onClick={() => navigate('/auth')} 
              data-testid="login-button"
              className="relative px-8 py-4 border-2 border-[#D4AF37] bg-black hover:shadow-[0_0_40px_rgba(212,175,55,0.8),0_0_60px_rgba(212,175,55,0.4)] transition-all duration-300 group"
            >
              <div className="text-center">
                <div className="text-white text-xs tracking-[0.3em] font-light mb-1">DIAMOND ACCESS</div>
                <div className="text-[#D4AF37] text-sm tracking-widest font-semibold">Member Login</div>
              </div>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;